function unsubscribe() {
  const unsubscribeContainer = document.querySelector(".js-unsubscribe-container");
  const unsubscribeForm = unsubscribeContainer.querySelector("form");
  const unsubscribeDescription = unsubscribeContainer.querySelector(".description");
  const unsubscribeSuccessMsg = unsubscribeContainer.querySelector(".unsubscribe_success-msg");

  unsubscribeForm.addEventListener("submit", (e) => {
    e.preventDefault();
    const email = unsubscribeForm.querySelector('input[type="email"]').value;
    const cordialAuth = "NjNlMTU4MTkxMjgxMzFlMTNlMGVjYjE4LW9hWHhzWGdJempmRERBNkJpcVBoSnd1Mzg5UTlBOWZJOg==";
    const cordialBody = {
        "channels": {
          "email": {
            "address": email,
            "subscribeStatus": "unsubscribed"
          }
        },
        "identifyBy": ["email"]
    }

    fetch("https://api.usw2.cordial.io/v2/contacts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${cordialAuth}`,
      },
      body: JSON.stringify(cordialBody),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then(() => {
        unsubscribeDescription.classList.add("hidden");
        unsubscribeSuccessMsg.classList.remove("hidden");
        unsubscribeForm.classList.add("hidden");
      })
      .catch((error) => {
        console.error(error);
      });
  });
}

document.addEventListener("DOMContentLoaded", unsubscribe);
